import HeroSection from "./HeroSection";
import FounderStorySection from "./FounderStory";
import MissionSection from "./MissionSection";
import CoreTeamSection from "./CoreTeamSection";
import AdvisorsSection from "./AdvisorsSection";
import CTAFooterSection from "./CTAFooterSection";

export default function OurTeam() {
  return (
    <div className="min-h-screen bg-white w-full">
      <HeroSection />
      <FounderStorySection />
      <MissionSection />
      <CoreTeamSection />
      <AdvisorsSection />
      <CTAFooterSection />
    </div>
  );
}
